module.exports = __webpack_public_path__ + "static/img/tip3.e412a28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tip3.png
// module id = yvk9
// module chunks = 1